import React from "react";
import { PageHero } from "../components/Shared";
import { Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ProfessionDeFoi() {
  return (
    <div className="bg-[#FDFBF7] min-h-screen">
      <PageHero
        label="Sénatoriales 2026 · Haut-Rhin"
        title="Profession de foi"
        subtitle="Le document officiel de notre liste adressé aux Grands Électeurs du Haut-Rhin — recto et verso"
      />
      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
        <div className="text-center mb-10">
          <a
            href={`${API}/api/profession-de-foi.pdf`}
            target="_blank"
            rel="noreferrer"
            data-testid="pf-download-pdf"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#12495B] text-[#F5C518] font-extrabold uppercase tracking-wide hover:bg-[#0E3A49] transition-colors duration-300"
          >
            <Download size={18} /> Télécharger la profession de foi (PDF)
          </a>
        </div>
        <div data-testid="pf-content" className="space-y-10">
          <img
            src={`${API}/api/static/profession-de-foi-recto.jpg`}
            alt="Profession de foi — recto"
            data-testid="pf-page-recto"
            className="w-full rounded-xl shadow-[0_15px_45px_rgb(0,0,0,0.15)] border border-slate-200"
          />
          <img
            src={`${API}/api/static/profession-de-foi-verso.jpg`}
            alt="Profession de foi — verso"
            data-testid="pf-page-verso"
            className="w-full rounded-xl shadow-[0_15px_45px_rgb(0,0,0,0.15)] border border-slate-200"
          />
        </div>
      </section>
    </div>
  );
}
